var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"headerButtonText--text px-6 ml-sm-4 mt-3 mt-sm-0",attrs:{"depressed":"","rounded":"","color":"#dddddd"},on:{"click":_vm.goBack}},[_c('v-icon',{attrs:{"color":"buttonText","left":""}},[_vm._v("mdi-arrow-left")]),_vm._v(" Back to Data Entry ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }